export async function csvDownloader(csvData: string, fileName: string) {
    try {
        const blob = new Blob([csvData], { type: 'text/csv' });

        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error('Error downloading CSV:', error);
    }
}
